import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_AUTOSAVE_INTERVAL_SECONDS } from "constants/add-in";
import { omit } from "lodash";

export const INITIAL_STATE = {
  accessToken: null,
  accessTokenExpiresInSeconds: null,
  authorities: [],
  autosaveEnabled: true,
  autosaveIntervalSeconds: DEFAULT_AUTOSAVE_INTERVAL_SECONDS,
  currentWorkspaceId: null,
  isInitialized: false,
  refreshToken: null,
  refreshTokenExpiresAt: null,
  ssoEnabled: null,
  username: null,
  workspaces: [],
};

export const addInAuthSlice = createSlice({
  name: "authentication",
  initialState: INITIAL_STATE,
  reducers: {
    resetAuthentication: () => {
      const result = omit(INITIAL_STATE, ["isInitialized"]);
      return {
        ...result,
        isInitialized: true,
      };
    },

    setAccessToken: (state, { payload }) => {
      state.accessToken = payload;
    },

    setAutosaveEnabled: (state, { payload }) => {
      state.autosaveEnabled = Boolean(payload);
    },

    setCurrentUser: (state, { payload }) => {
      const { authorities, currentWorkspaceId, username, workspaces } =
        payload || {};
      state.authorities = authorities || [];
      state.currentWorkspaceId = currentWorkspaceId ?? null;
      state.username = username;
      state.workspaces = workspaces;

      if (typeof payload?.autosaveEnabled === "boolean") {
        state.autosaveEnabled = payload.autosaveEnabled;
      }

      const intervalSeconds = payload?.settings?.autosaveIntervalSeconds;
      if (Number.isFinite(intervalSeconds) && intervalSeconds > 0) {
        state.autosaveIntervalSeconds = intervalSeconds;
      }
    },

    setIsInitialized: (state, { payload }) => {
      state.isInitialized = payload;
    },

    setSsoEnabled: (state, { payload }) => {
      state.ssoEnabled = Boolean(payload);
    },

    setTokens: (state, { payload }) => {
      state.accessToken = payload.accessToken;
      state.accessTokenExpiresInSeconds = payload.accessTokenExpiresInSeconds;
      state.refreshToken = payload.refreshToken;
      state.refreshTokenExpiresAt = payload.refreshTokenExpiresAt;
    },
  },
});

export const {
  resetAuthentication,
  setAccessToken,
  setAutosaveEnabled,
  setCurrentUser,
  setIsInitialized,
  setSsoEnabled,
  setTokens,
} = addInAuthSlice.actions;
